import React from 'react';
import { GridOverlay } from '@mui/x-data-grid';
import Loading from '../components/Loading';
import { H } from '../Layout';
import { useStyling } from '../Theme';

export default () => {
    const { theme } = useStyling();
    return (
        <GridOverlay>
            <H sx={{ height: '100%', bgcolor: 'var(--DataGrid-overlayBackground)' }}>
                <Loading />
            </H>
        </GridOverlay>
    );
};
